import * as ScrollMagic from "scrollmagic"; // Or use scrollmagic-with-ssr to avoid server rendering problems

/**
 *
 *
 * @module stickySideBar
 *
 * To debugging the scrolling and elements position,
 * uncomment the funciton ".addIndicators()" in the code base to show the Indicators in frontend
 * for more infomation please visit
 * http://scrollmagic.io/examples/basic/scene_manipulation.html
 */
(function stickySideBar() {

    function stickySideBar($dom) {
        /**
         * // local object availability
         * @type {stickySideBar}
         * @private
         */
        var _this = this;


        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            this.domHeight = $dom[0].clientHeight;
            this.headerHeight = $("[data-html-element='header']")[0].clientHeight;
            this.tourAnchorLinksNavigationHeight = $("[data-element='tour-anchor-links-navigation']")[0].clientHeight;
            this.offset = '-' + (_this.headerHeight + _this.tourAnchorLinksNavigationHeight + 30);
            this.duration = $("[data-element='scrolling-content-area-left-side']")[0].clientHeight - _this.domHeight - 20;
            _this.activateStickySideBar();
        };


        /**
         * activateStickySideBar
         * @returns {undefined}
         */
        this.activateStickySideBar = function() {
            var pin = new ScrollMagic.Scene({
                triggerElement: $dom[0],
                triggerHook: 0,
                duration: _this.duration,
                offset: _this.offset
            }).setPin($dom[0])
            /** to debugging the scrolling and element position, uncomment the line below to show the Indicators in frontend */
                // .addIndicators()
                .addTo(new ScrollMagic.Controller());
        };


        /**
         * initialize call
         */
        _this.init();
    }


    // define the global scope
    if (!window.Bikealpin) {
        window.Bikealpin = {};
    }

    window.Bikealpin.stickySideBar = stickySideBar;
})();


$(document).ready(function () {
    var currentWindowWidth = $(window).width();
    var breakPoint = 992;
    var $tourTeaserBookingCardElement = $("[data-element='tour-teaser-booking-card']");
    if ($tourTeaserBookingCardElement.length >= 1 & currentWindowWidth > breakPoint ) {
        new window.Bikealpin.stickySideBar($tourTeaserBookingCardElement);
    }
});
